/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const userAccount = {
  loginForm: {
    title: 'Iniciar sessão',
    forgotPassword: 'Esqueceu sua senha?',
    signIn: 'Iniciar sessão',
    register: 'Inscrição',
    dontHaveAccount: 'Não tem uma conta?',
    guestCheckout: 'Pagamento de convidado',
    emailAddress: {
      label: 'Endereço eletrônico',
      placeholder: 'Digite o e-mail',
    },
    password: {
      label: 'Senha',
      placeholder: 'Senha',
    },
    wrongEmailFormat: 'Este não é um formato de e-mail válido.',
  },
  miniLogin: {
    userGreeting: 'Olá, {{name}}',
    signInRegister: 'Iniciar sessão',
  },
};
